import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TitleService } from '@app/services/title.service';
import { ToastService } from '@app/services/toast.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogModel } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { IToolTable } from '@app/interfaces/IToolTable';
import { ToolsService } from '@app/services/tools.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Messages } from '@app/util/messages';
import { TourGuideContent } from '@app/util/tour-guide-content.util'
import { AuthService } from '@app/services/auth/auth.service';
import { ConstantsService } from '@app/services/constants.service';
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';
import { TourGuideService } from '@app/services/tour-guide.service';

@Component({
  selector: 'app-view-tool',
  templateUrl: './view-tool.component.html',
  styleUrls: ['./view-tool.component.scss']
})
export class ViewToolComponent implements OnChanges {

  /****************** Variable declaration ******************/
  tourGuideIds = TourGuideContent
  refreshIcon = 'Refresh';
  features: any = {};
  editModalContent = false;
  openModal = 'open-tool-modal';
  showModal = false;
  editIcon = this.titleService.editIcon;
  deleteIcon = this.titleService.deleteIcon;
  activeTool = this.titleService.activeTool;
  displayedData: IToolTable[];
  getNoData = Messages.no_data;  //for getting no data available message

  displayedColumns: string[] = ['toolNm', 'version', 'licType', 'osNm', 'total', 'minCnt', 'availCnt', 'inUseCnt', 'active', 'action', 'refresh'];
  columnHeaders: { [key: string]: string } = {
    'toolNm': 'Name',
    'version': 'Version',
    'licType': 'License type',
    'osNm': 'OS',
    'availCnt': 'Available',
    'inUseCnt': 'In use',
    'total': 'Total',
    'active': 'Active',
    'action': 'Action',
    'minCnt': 'Min count'
  };

  /****************** Input and Output decorators ******************/
  @Input() dataSource: MatTableDataSource<IToolTable>;
  @Output() editRow = new EventEmitter<any>();

  /****************** View child ******************/
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  /**
   * constructor
   * @param ts 
   * @param titleService 
   * @param dialog 
   * @param toolsService 
   * @param authService 
   * @param constantsService 
   * @param cf
   */
  constructor(private ts: ToastService,
    private titleService: TitleService,
    public dialog: MatDialog,
    private toolsService: ToolsService,
    public authService: AuthService,
    public constantsService: ConstantsService,
    public cf: CommonFunctionalitiesService,
    public tourGuideService: TourGuideService) { }

  /**
   * ngOnChanges
   * @param changes 
   */
  ngOnChanges(changes: SimpleChanges): any {
    this.dataSource.paginator = this.paginator;
  }

  /**refresh tool details */
  refreshViewTool() {
    this.getToolDetails();
  }

  /**
   * Event emitter that will be passed to the parent component
   * For emitting the row data
   * @param element
   */
  editToolList(element: any) {
    if (!this.authService.permissions['edit-tool']) return; //check for access
    this.editRow.emit(element);
  }

  /**get formatted value for numbers to display as compact numbers */
  getFormattedValue(column: string, value: any) {
    if (column === 'total' || column === 'inUseCnt' || column === 'minCnt' || column === 'availCnt') {
      if (value === 'NA') {
        return value;
      }
      const numberValue = parseFloat(value);
      if (!isNaN(numberValue)) {
        return this.cf.formatCompactNumber(numberValue);
      }
    }
    return value;
  }

  /****************************Api calls *****************************/

  /**get tool details */
  getToolDetails() {
    this.toolsService.getToolDet().subscribe((response: any) => {
      this.dataSource = new MatTableDataSource<any>(response?.data.dbResp);
      this.dataSource.paginator = this.paginator;
    });
  }

  /**
   * Deletes the saved configuration in tools table
   * @param i
   */
  onDelete(data: any) {
    if (!this.authService.permissions['delete-tool']) return; //check for access

    const dialogData = new ConfirmDialogModel(Messages.confirmdialog_delete_title, Messages.confirmdialog_delete_msg);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "370px",
      disableClose: true,
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((dialogResult: boolean) => {
      if (dialogResult === true) {
        this.toolsService.deleteTool(data.toolId).subscribe(
          (response: any) => {
            const index = this.dataSource.data.indexOf(data);
            if (index > -1) {
              this.dataSource.data.splice(index, 1);
              this.dataSource._updateChangeSubscription();
            }
            this.ts.showSuccess('Delete', 'Tool deleted successfully');
          },
          (error: any) => {
            this.ts.showError('Error', 'Tool cannot be deleted');
          }
        );
      }
    });
  }
}
